import BaseComponentController from '.././base-component.controller';
import * as GiftValue from '../../constants/giftValue';
import * as ResponsibleOfficerType from '../../constants/responsibleOfficerType';

class AlternativeExecutiveManagerController extends BaseComponentController {

    constructor(_, componentRegistryService, $q) {
        super(_, componentRegistryService, $q);
        this.vm = {
            alternativeOfficer: this.alternativeOfficer,
            reportingManagerToDisplay: null,
            lineManager: this.lineManager
        }
    }
    
    init() {
        this.vm = {
            alternativeOfficer: this.alternativeOfficer,
            reportingManagerToDisplay: null,
            lineManager: this.lineManager
        }
        this._updateDisplayedManagerUI(this.managerType);
    }
    
    validate() {
        return true;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }

    $onChanges(changesObj) {
        this._updateDisplayedManagerUI(changesObj.managerType.currentValue);
    }

    _updateDisplayedManagerUI(managerType) {
        if (managerType === ResponsibleOfficerType.LineManager) {
            if (this.lineManager) {
                this.vm.reportingManagerToDisplay = `Your Line Manager ${this.lineManager.fullName} (${this.lineManager.positionTitle}) will be contacted to approve this disclosure.`;
            } else {
                this.vm.reportingManagerToDisplay = "This disclosure will be processed by the Integrity and Standards Unit.";
            }
        }
        if (managerType === ResponsibleOfficerType.ExecutiveManager) {
            this.vm.reportingManagerToDisplay = `Including the gift you are now registering, either the value of the gift exceeds $${GiftValue.ExecutiveGiftValue}, or the total value of all gifts received from the individual or organisation during the preceding 12 month period exceeds $${GiftValue.ExecutiveGiftValue}. Therefore, the disclosure will be processed by an Executive Manager.`;
        }
    }

    displayLineManager() {
        return this.managerType === ResponsibleOfficerType.LineManager && this.lineManager && !this.alternativeOfficer && this.readonly;
    }

    showResponsibleOfficerMessage() {
        return !this.readonly || !(this.vm.lineManager || this.vm.alternativeOfficer || this.managerType === ResponsibleOfficerType.ExecutiveManager);
    }
}

AlternativeExecutiveManagerController.$inject = ['_', 'componentRegistryService','$q'];

export default {
    bindings: {
        lineManager: '<',
        executiveManagers: '<',
        alternativeOfficer: '<',
        readonly: '<',
        managerType: '<',
        modelName: '@',
        fieldName: '@'
    },
templateUrl: 'app/components/line-alternative-executive-manager/line-alternative-executive-manager.html',
controller: AlternativeExecutiveManagerController
};


// WEBPACK FOOTER //
// ./app/components/line-alternative-executive-manager/line-alternative-executive-manager.component.js